import BaseUI from "./BaseUI";
import { UIStates, UIModes } from "./UIStates";
import InstanceFactory from "../../src/factories/InstanceFactory";
import AbstractPopup from "./popups/AbstractPopup";
import { UIUpdateEvent } from "./UIUpdateEvents";
import ConsoleUtil from '../utils/ConsoleUtil';

class UIController {
    public components: Map<string, BaseUI | AbstractPopup> = new Map();
    protected uiMap: Map<string, FunctionConstructor> = new Map();
    public errorPopup: AbstractPopup;
    public messagePopup: AbstractPopup;
    protected mode:UIModes | string;
    protected state:UIStates | string;

    public create() {
        this.components.forEach(el => {
            el.create();
        });
        this.errorPopup = this.components.get('errorPopup') as AbstractPopup;
        this.messagePopup = this.components.get('messagePopup') as AbstractPopup;
    }

    public updateFields(event?: UIUpdateEvent, props?: any) {
        this.components.forEach(el => {
            el.update(event ,props);
        });
    }

    public setMode(mode:UIModes | string) {
        // ConsoleUtil.logWithColor("[UI] Set MODE: " + mode, 0x34eb8c);
        this.mode = mode;
    }

    public getCurrentMode() {
        return this.mode;
    }

    public getCurrentState() {
        return this.state;
    }

    public setState(state: UIStates | string) {
        // ConsoleUtil.logWithColor("[UI] Set STATE: " + state + " (mode: " + (this.mode || "DEFAULT") + ")", 0xfafa82);
        this.state = state;
        this.components.forEach(el => {
            el.setState(state,this.mode);
        });
    }

    public toggleComponent(name: string, arg?) {
        let component = this.components.get(name);
        if (component instanceof AbstractPopup) {
            component.toggle(arg);
            component.setState(this.state,this.mode);
        }
    }

    public isComponentHidden(name: string): boolean {
        if (!this.components.has(name)) {
            return true;
        }
        let component = this.components.get(name);
        return component.isHidden;
    }

    public setComponent(name:string, component: BaseUI | AbstractPopup) {
        this.components.set(name, component)
    }
}

export default new UIController();
